export const defaultConfirmationPaneConfirmButtonFocusedStyles = {
  border: "2px dotted #000"
};